document.addEventListener('click', function(event) {
  // Check if the clicked element is a link or is inside a link
  const link = event.target.closest('a');

  if (link && link.href) {
    const url = new URL(link.href, window.location.href);
    const currentDomain = window.location.hostname;

    // Check if it's an external link
    if (url.hostname !== currentDomain) {
      event.preventDefault();
      window.open(link.href, '_blank', 'noopener,noreferrer');
    }
  }
});
